import React, {useState, useEffect, useContext} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import FullBodyContentView from '../../views/fullBodyContentView';

function LifetimeStats({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
    onExit();
  }, [leftPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft: onExit});
    });
  }, [onExit]);
  return (
    <FullBodyContentView
      title="View Lifetime Statistics"
      fullCaption="Powered On Time.........0.................
      Powered Cycles............0.................
      Max Sensor Temp......-1000.000f.....
      Min Sensor Temp......+1000.000f.....
      Ave Sensor Temp......O°C...............
      Max Transmitter.......-1000.000f.......
      "
    />
  );
}

export default LifetimeStats;
